(() => {
  if (customElements.get('milwaukee-recommendations')) return;
  customElements.define('milwaukee-recommendations', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.initialize();
    }
    async initialize() {
      const signal = this.controller.signal;
      if (this.dataset.url && !this.querySelector('.mw-recommendations__card')) {
        try {
          const response = await fetch(this.dataset.url, { signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error('Recommendations unavailable');
          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          const source = [...documentFragment.querySelectorAll('milwaukee-recommendations')].find(el => el.dataset.sectionId === this.dataset.sectionId);
          const content = source && source.querySelector('[data-recommendations-content]');
          if (signal.aborted) return;
          if (!content || !content.querySelector('.mw-recommendations__card')) { this.hidden = true; return; }
          this.querySelector('[data-recommendations-content]').innerHTML = content.innerHTML;
        } catch (error) {
          if (!signal.aborted) this.hidden = true;
          return;
        }
      }
      if (signal.aborted) return;
      this.track = this.querySelector('.mw-recommendations__track');
      if (!this.track) { this.hidden = true; return; }
      this.hidden = false;
      if (this.nextElementSibling?.classList.contains('mw-recommendations__editor-note')) this.nextElementSibling.hidden = true;
      this.buttons = [...this.querySelectorAll('[data-step]')];
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-step]');
        if (!button) return;
        this.track.scrollBy({ left: Number(button.dataset.step) * this.track.firstElementChild.getBoundingClientRect().width, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, { signal });
      this.track.addEventListener('scroll', () => this.update(), { signal, passive: true });
      document.addEventListener('shopify:block:select', event => {
        const card = [...this.track.children].find(el => el.dataset.blockId === event.detail.blockId);
        if (card) this.track.scrollTo({ left: card.offsetLeft - this.track.firstElementChild.offsetLeft, behavior: 'instant' });
      }, { signal });
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.update();
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.buttons.forEach(button => {
        button.hidden = max < 2;
        button.disabled = Number(button.dataset.step) < 0 ? this.track.scrollLeft <= 2 : this.track.scrollLeft >= max - 2;
      });
    }
    disconnectedCallback() { this.controller.abort(); this.observer?.disconnect(); }
  });
})();
